import { RootState } from "lib/redux/root/redux.types";

export const selectMhm = (state: RootState) => state.mhm;
export const selectMhmCategoryList = (state: RootState) =>
  state.mhm.categoryList;
export const selectMhmSystemSettings = (state: RootState) =>
  state.mhm.systemSettings;
